const SomalilandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112387)">
      <path
        d="M38.756 26.9568C39.5599 24.7902 40 22.4467 40 20.0003C40 17.5539 39.5599 15.2105 38.756 13.0438L20 11.3047L1.24398 13.0438C0.440078 15.2105 0 17.5539 0 20.0003C0 22.4467 0.440078 24.7902 1.24398 26.9568L20 28.6959L38.756 26.9568Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9299 34.573 38.7557 26.957H1.24365C4.06959 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06959 5.4275 1.24365 13.0435H38.7558C35.9299 5.4275 28.599 0 19.9997 0Z"
        fill="#496E2D"
      />
      <path
        d="M19.9998 15.6514L21.0789 18.9727H24.5713L21.746 21.0256L22.8253 24.347L19.9998 22.2944L17.1743 24.347L18.2536 21.0256L15.4282 18.9727H18.9206L19.9998 15.6514Z"
        fill="black"
      />
      <path
        d="M25.9421 3.91309V7.97098C25.9421 8.61043 25.422 9.13043 24.7827 9.13043V10.8696C26.381 10.8696 27.6812 9.56934 27.6812 7.97098V3.91309H25.9421Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.4783 7.97098C13.4783 8.61043 12.9582 9.13043 12.3188 9.13043V10.8696C13.9172 10.8696 15.2174 9.56934 15.2174 7.97098V3.91309H13.4783V7.97098Z"
        fill="#F0F0F0"
      />
      <path d="M23.333 3.91309H25.0721V7.97098H23.333V3.91309Z" fill="#F0F0F0" />
      <path
        d="M20.7246 6.23184C20.7246 6.39168 20.5946 6.52176 20.4348 6.52176C20.275 6.52176 20.1449 6.39168 20.1449 6.23184V3.91309H18.4057V6.23184C18.4057 6.39168 18.2757 6.52176 18.1159 6.52176C17.9561 6.52176 17.8261 6.39168 17.8261 6.23184V3.91309H16.0869V6.23184C16.0869 7.35074 16.9971 8.2609 18.1159 8.2609C18.5468 8.2609 18.9464 8.12551 19.2753 7.89559C19.6043 8.12551 20.0039 8.2609 20.4347 8.2609C20.5215 8.2609 20.6068 8.2548 20.6907 8.2441C20.5675 8.75184 20.1102 9.13043 19.5652 9.13043V10.8696C21.1635 10.8696 22.4637 9.56934 22.4637 7.97098V6.23184V3.91309H20.7246L20.7246 6.23184Z"
        fill="#F0F0F0"
      />
      <path d="M16.0869 9.12988H18.6956V10.869H16.0869V9.12988Z" fill="#F0F0F0" />
    </g>
    <defs>
      <clipPath id="clip0_4152_112387">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SomalilandSvg;
